import { useEffect, useState } from "react";
import axios from "axios";
import { History } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ChangeRow = ({ c, i }) => (
  <li data-testid={`change-row-${i}`} className="py-2.5">
    <div className="flex items-center gap-2 text-xs text-slate-500">
      <span>{new Date(c.at).toLocaleString("nl-NL")}</span>
      <span className="rounded-full bg-slate-100 px-2 py-0.5 font-medium text-slate-600">{c.source}</span>
    </div>
    <div className="mt-0.5 text-sm font-semibold text-slate-900">{c.field}</div>
    {(c.old || c.new) && (
      <div className="mt-0.5 text-sm">
        <span className="text-red-600 line-through break-all">{c.old || "(leeg)"}</span>
        <span className="mx-1.5 text-slate-400">→</span>
        <span className="text-green-700 break-all">{c.new || "(leeg)"}</span>
      </div>
    )}
  </li>
);

export const ChangeLog = ({ club, onClose }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!club) return;
    setRows(null);
    axios.get(`${API}/leads/${club.id}/changes`).then(({ data }) => setRows(data)).catch(() => setRows([]));
  }, [club]);
  return (
    <Dialog open={!!club} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="changelog-dialog" className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            <History className="w-5 h-5 text-[#FF4500]" /> Wijzigingen — {club?.name}
          </DialogTitle>
          <DialogDescription>Alle wijzigingen: handmatig in de tabel, via Excel-upload, scraper, herstel of verplaatsen — nieuwste eerst.</DialogDescription>
        </DialogHeader>
        {rows === null ? (
          <p className="text-sm text-slate-400">Laden…</p>
        ) : rows.length === 0 ? (
          <p data-testid="changelog-empty" className="text-sm text-slate-500">Nog geen wijzigingen vastgelegd voor deze lead.</p>
        ) : (
          <ul className="max-h-[60vh] overflow-auto divide-y divide-slate-100">
            {rows.map((c, i) => <ChangeRow key={c.id} c={c} i={i} />)}
          </ul>
        )}
      </DialogContent>
    </Dialog>
  );
};
